import moment from "moment";
import React, { useMemo, useState } from "react";
import { HiOutlinePencilAlt } from "react-icons/hi";
import { useGroupChatContext } from "../../context/groupchatContext";
import { titleWithoutUnderscore } from "../../helpers/utility";
import { AppointmentsFollowUp } from "../../pages/appointment/followupAppointment";
import MainPageDialog from "../dialog";

export const AppointmentRequestMessage = ({msg, isLoggedInUser}) => {

    const groupChatContext = useGroupChatContext();
    const {authData} = useMemo(() => ({
        authData: groupChatContext.authData,
    }));

    const [isOpenAppt, setIsOpenAppt] = useState(false)

    const isPendingAppointment = msg.message.data?.status?.toLowerCase() == 'pending'

    return (
        <>
            <div className={`rounded-md ${isLoggedInUser() ? 'bg-blue-100': 'bg-white border'}  p-2 shadow`}>
                <div className={`text-gray-800 text-start`}>
                    <h1 className={`flex gap-2 justify-between capitalize font-bold border-b py-1 px-2 rounded-t-md`}>
                        {isPendingAppointment ? titleWithoutUnderscore(msg.message?.event_type) : 'Appointment'}
                        {(authData?.is_provider && isPendingAppointment) ? <HiOutlinePencilAlt title="Edit Appointment" onClick={()=>setIsOpenAppt(true)} className="mt-1 h-5 w-5 cursor-pointer" /> : null }
                    </h1>
                    <div className={`p-2 rounded-b-md`}>
                        <p><span className="font-semibold">Date:</span> {moment(msg.message.data?.start_date).format('MM/DD/YYYY hh:mm A')}</p>
                        <p><span className="font-semibold">Status:</span> {msg.message.data?.status}</p>
                    </div>
                </div>
            </div>

            {isOpenAppt ?
                <MainPageDialog
                    title="Edit Appointment"
                    onCancelHandler={() => setIsOpenAppt(false)}
                    // modalSize="md"
                    maxHeight={true}
                    customHeight={"min-h-[80vh] overflow-y-auto"}
                    component={
                        <AppointmentsFollowUp apptId={msg.message.data?.id} closeApptPopup={() => setIsOpenAppt(false)} />
                    }
                    footer={false}
                >
                </MainPageDialog>
                : null
            }
        </>
    );
};